import {
  ValidationError,
  type ValidationErrorOptions,
} from '../validation/types.js';

/**
 * A form-wide error that is not tied to any single input — an authentication
 * failure, a disabled submission, a server-side rejection that applies to the
 * whole form.
 *
 * @remarks
 * Routed by `formId` to the form-wide `FormMessages` outlet under `<Form>`. It
 * is never pushed through `setCustomValidity` because there is no native input
 * for "the form". The inherited `formControlId` is typically `undefined`.
 *
 * @internal
 */
export class FormValidationError extends ValidationError {
  /** Routing target — the id of the `<Form>` whose `FormMessages` renders this. */
  readonly formId: string;

  constructor(
    message: string,
    options: ValidationErrorOptions & { formId: string },
  ) {
    super(message, options);
    this.name = 'FormValidationError';
    this.formId = options.formId;
  }
}
